import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";

import { ShoppingActions } from ".";
import { getShoppingApi } from "./api";

export default function* shopping(): SagaIterator {
  try {
    const response = yield call(getShoppingApi);
    const { data } = response;
    yield put(ShoppingActions.success(data?.response));
  } catch (e) {
    yield put(ShoppingActions.error());
  }
}
